// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const rfc: CountryValidator<"MX"> = createValidator(
  "mx.rfc",
  130,
);

export default rfc;
export const compact = rfc.compact;
export const format = rfc.format;
export const validate = rfc.validate;
export const generate = (): string =>
  rfc.generate?.() ??
  (() => {
    throw new Error(
      "Validator mx.rfc cannot generate values",
    );
  })();
